import React from "react";
import Tooltip from "@material-ui/core/Tooltip";
import CircularProgress from "@material-ui/core/CircularProgress";
import HourglassEmptyIcon from "@material-ui/icons/HourglassEmpty";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";
import { amber, green, red } from "@material-ui/core/colors";
import Table from "components/enhancedTable";
import { useBackgroundJobs, getJobDescription, getJobCooperative } from "hooks/useBackgroundJobs";

/* const etl = jobs =>
  jobs.map(job => [
    getJobLabel(job),
    job.cooperative || "—",
    <RenderJobStatus status={job.status} />,
    job.timestamp ? new Date(job.timestamp).toLocaleString() : "—",
    job.completedAt ? new Date(job.completedAt).toLocaleString() : "—",
  ]); */
const etl = jobs =>
  jobs.map(job => [
    getJobDescription(job),
    getJobCooperative(job),
    <RenderJobStatus status={job.status} />,
    job.timestamp ? new Date(job.timestamp).toLocaleString() : "—",
    job.message || "—"
  ]);  

export default function BackgroundJobsTable() {
  const { jobs, loading, error } = useBackgroundJobs();

  if (loading) return <p>Caricamento...</p>;
  if (error) return <p>Errore nel caricamento dei processi.</p>;

  return (
    <Table
      headers={["Descrizione / Tipo", "Cooperativa", "Stato", "Data/Ora Inizio", "Messaggio"]}
      rows={etl(jobs)}
      sort="desc"
      sortBy="Data/Ora Inizio"
    />
  );
}

const RenderJobStatus = ({ status }) => {
  if (status === "QUEUED" || status === "NEW")
    return (
      <Tooltip title={status} placement="top">
        <HourglassEmptyIcon style={{ color: amber[600] }} />
      </Tooltip>
    );
  if (status === "IN_PROGRESS" || status.endsWith('ING'))
    return (
      <Tooltip title={status} placement="top">
        <CircularProgress disableShrink size={20} />
      </Tooltip>
    );
  if (status === "SUCCESS")
    return (
      <Tooltip title={status} placement="top">
        <CheckCircleIcon style={{ color: green[600] }} />
      </Tooltip>
    );
  if (status === "ERROR")
    return (
      <Tooltip title={status} placement="top">
        <ErrorOutlineIcon style={{ color: red[600] }} />
      </Tooltip>
    );
  return status || null;
};
